__turbopack_context__.v({
  "activity_nav_child": "StaySubmenu-module-scss-module__HnjNPW__activity_nav_child",
  "activity_nav_items_left": "StaySubmenu-module-scss-module__HnjNPW__activity_nav_items_left",
  "activity_nav_items_right": "StaySubmenu-module-scss-module__HnjNPW__activity_nav_items_right",
  "activity_text": "StaySubmenu-module-scss-module__HnjNPW__activity_text",
  "img_box": "StaySubmenu-module-scss-module__HnjNPW__img_box",
});
